/* @jsx h */
import { defineComponent, h } from "vue";
import { RewardDays } from "@lemmonhq/types";
import { daysOfWeek as DAYS } from "@lemmonhq/orders";
import { cn } from "@lemmonhq/uikit";

export type DaySelectProps = {
  value: RewardDays;
  onChange: (days: RewardDays) => void;
};
export const DaySelect = defineComponent<DaySelectProps>({
  name: "DaySelect",
  props: ["value", "onChange"],
  setup(props) {
    const addTimeRange = (day: string) => {
      const currentRanges = props.value[day] || [];
      const newDays = {
        ...props.value,
        [day]: [...currentRanges, { start_time: "09:00", end_time: "17:00" }],
      };
      props.onChange(newDays);
    };

    const removeTimeRange = (day: string, index: number) => {
      const newRanges = [...(props.value[day] || [])];
      newRanges.splice(index, 1);
      const newDays = {
        ...props.value,
        [day]: newRanges,
      };
      if (newRanges.length === 0) {
        delete newDays[day];
      }
      props.onChange(newDays);
    };

    const updateTimeRange = (
      day: string,
      index: number,
      field: "start_time" | "end_time",
      value: string,
    ) => {
      const newRanges = [...(props.value[day] || [])];
      newRanges[index] = {
        ...newRanges[index],
        [field]: value,
      };
      props.onChange({
        ...props.value,
        [day]: newRanges,
      });
    };

    return () => (
      <div class="space-y-4">
        {DAYS.map((day) => (
          <div key={day} class="card border ">
            <div class="card-body p-4">
              <div class="flex items-center justify-between mb-4">
                <h4
                  class={cn(
                    "card-title text-lg uppercase font-normal",
                    props.value[day] && "text-accent font-semibold",
                  )}
                >
                  {day}
                </h4>
                <button
                  type="button"
                  class="btn btn-sm btn-neutral"
                  onClick={() => addTimeRange(day)}
                >
                  <span class="text-lg">+</span>
                </button>
              </div>

              <div class="space-y-3">
                {(props.value[day] || []).map((range, index) => (
                  <div key={index} class="flex items-center gap-4">
                    <input
                      type="time"
                      value={range.start_time}
                      onChange={(e) =>
                        updateTimeRange(
                          day,
                          index,
                          "start_time",
                          (e.target as HTMLInputElement).value,
                        )
                      }
                      class="input input-bordered input-sm focus:input-primary"
                    />
                    <span class="text-base-content/70">to</span>
                    <input
                      type="time"
                      value={range.end_time}
                      onChange={(e) =>
                        updateTimeRange(
                          day,
                          index,
                          "end_time",
                          (e.target as HTMLInputElement).value,
                        )
                      }
                      class="input input-bordered input-sm focus:input-primary"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-ghost btn-square text-error hover:bg-error/10"
                      onClick={() => removeTimeRange(day, index)}
                      title="Remove time range"
                    >
                      <span class="material-symbols-outlined text-lg">
                        delete
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  },
});
